<style lang="stylus" scoped>
@import './cardMap.stylus';

.title {
  span {
    margin: 0px 15px;
    border-bottom: 3px solid transparent;
    color: #999999;
    display: inline-block;
    height: auto;
    line-height: 2;
  }

  span.active {
    border-color: #336CAF;
    color: #326DAF;
  }
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.map-area {
  margin-top: 20px;
}

</style>

<template>
  <div>
    <dimension-dialog v-if="showExport" @hideExport="hideExport1"  :moduleName="moduleName"/>
    <detailsData v-if="showDetails" :dimObj="getNewDimObj()" :priviceName="priviceName" :value="value4" :registProvcode="registProvcode" :fuelType="fuelType" @closeDetails="closeDetails"/>
    <div v-else class="home-main">
      <div class="mark" v-if="mark">
        <el-progress type="circle" :percentage="progressNum" class="circle" style="color:#fff;"></el-progress>
      </div>
      <tabTon :titleArr="titleArr" :changeType="changeType" :dataType="dataType" :path="path">
        <el-button v-show="hideExport" style="float: right;margin-right: 10px;margin-top: 26px;" @click="exportDate">导出</el-button>
        <el-select v-model="fuelType" @change="changeFuelType" style="width:150px;float: right;margin-right: 10px;margin-top: 26px;" placeholder="请选择燃油类型">
          <el-option
            v-for="(item,index) in fuelTypeList"
            :label="item.label"
            :value="item.value"
            :key="index"
          />
        </el-select>
      </tabTon>
      <div class="map-data"
      >
        <div class="map-area">
          <!--el-date-picker
            v-model="value4"
            type="month"
            placeholder="选择月"
            value-format="yyyy-MM"
            style="position: absolute;left: 40%;top: -3px;z-index:100"
            @change="changeTime"
          ></el-date-picker-->
          <div style="position: absolute;left: 40%;top: -5px;z-index:100;">
            <dimension-popover ref="objDimensionPopover" :isMapValue="true" :dimObj="dimObj" :change="changeDimension" :showBottomButton="false" :isItemBindClick="true" />
          </div>
          <home-map
            :dataType="dataType"
            :title="titleArr[dataType].title"
            :mapRangeList="mapRangeList"
            :dataItem="dataItem"
            :priviceName="priviceName"
            @getDetails="getDetails"
          ></home-map>
          <mapBox v-if="showtip"/>
        </div>
        <map-card :cardItem="dataItem" @getDetails="getDetails"></map-card>
      </div>
    </div>
    <div class="bottom-top" v-if="!showDetails">
      <h4><img src="../../../assets/images/title.png"> <span>说明</span></h4>
      <div>1.按车辆注册省：该地注册入网重载货车在各统计周期内，在全国范围内的活跃车辆数，可反映该注册省重载货车活跃度。</div>
      <div>2.按车辆运营省：全国各籍重载货车在某地（省/市/自治区）范围内的运营车辆数，可反映该运营省重载货车活跃度。【注】在统计时间内，1辆车在某省运营，则在该省计为1辆；在多省运营，则在多省分别计为1辆。</div>
      <div>3.吨位划分：以车辆总质量的吨位数进行区间划分。</div>
      <div>4.统计频率：按月统计，每月6日更新上月数据。</div>
      <div>5.下一级页面：点击地图对应省份或者右侧省份名称，可进入该省各地区运营车辆吨位分布统计页面。</div>
    </div>
  </div>
</template>

<script>
import homeMap from './components/map.vue'
import mapCard from './components/mapCard.vue'
import tabTon from '../component/tabTon.vue'
import detailsData from './components/details.vue'
import http from '@/api/freight'
// import cityData from './map-data/get-city-value.js'
import Cookies from 'js-cookie'
import Util from '@/utils/util'
//import exportDate from '@/components/exportDate'
import dimensionDialog from '@/components/exportDate/daphne/dialog.vue'
import dimensionPopover from '@/components/exportDate/daphne/popover.vue'
import { hideExport } from '@/utils/tools'
import { getFuelTypeList , getFuelTypeCode } from '@/utils/dictionary'
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
import set from 'lodash/set'
export default {
  name: 'home',
  components: {
    homeMap,
    mapCard,
    tabTon,
    detailsData,
    dimensionDialog,
    dimensionPopover,
  },
  data() {
    let fuelTypeList = getFuelTypeList();
    let value4=Util.lastTime(new Date());
    let arr = value4.split('-')
    let dimObj={
      year: arr[0],
      month: arr[1],
      type: "0",
    };
    let firstLoaded=true;
    return {
      firstLoaded,
      fuelTypeList,
      fuelType:"",
      hideExport:hideExport,
      showtip:false,
      moduleName:"operatorTonVehicle",
      priviceName:'',
      registProvcode:'',
      showExport:false,//控制批量导出
      //   cityData: [],
      path:"carOperateTon",
      areaList: [], //省列表
      dataType: 0, //点击省份详情列表
      titleArr: [
        {
          title: '',
          value: '',
          key: 'operatorSubtotal'
        },
        {
          title: '10吨以下',
          value: '',
          key: 'operator_0_10'
        },
        {
          title: '10(含)-25吨',
          value: '',
          key: 'operator_10_25'
        },
        {
          title: '25(含)-35吨',
          value: '',
          key: 'operator_25_35'
        },
        {
          title: '35吨(含)以上',
          value: '',
          key: 'operator_35'
        }
      ],
      showDetails: false,
      progressNum: 0, //进度条进度
      mark: false, //是否显示遮罩层
      value4,
      mapRangeList: [], //地图图例
      dataItem: [], // 地图数据
      nounArr: ['第1-3名', '第4-7名', '第8-12名', '第13-18名', '第19-31名'], //地图图例汉字
      dimObj,//纬度对像
    }
  },
  watch: {},
  computed: {},
  created() {
     if(Cookies.get('userType')!=2){
        this.initData()
     }
  },
  methods: {
    getNewDimObj(){
      if(Cookies.get('userType')==2){
        this.dimObj.month = '0' + (Number(this.dimObj.month) - 1);
      }
      return cloneDeep(this.dimObj)
    },
    // 取消导出
    hideExport1(){
      this.showExport=false
      this.initData()
    },
    getDetails(index,name,registProvcode) {
      this.priviceName=name
      this.registProvcode=registProvcode
      this.showDetails = true
    },
    closeDetails() {
      this.showDetails = false
      this.initData()
    },
    changeType(num) {
      this.dataType = num
      this.initData()
    },
    changeFuelType(){
      this.initData()
    },
    initTit() {
      let that = this
      let energyType = getFuelTypeCode(this.fuelType)
      let arr = that.value4.split('-')
      let type = get(this,"dimObj.type","0")
      http.carOperateTonAll({
          year: arr[0],
          month: arr[1],
          energyType,
          type
        })
        .then(e => {
          let arr = [...that.titleArr]
          arr[0].value = e.data.operatorSubtotal
          arr[1].value = e.data.operator_0_10
          arr[2].value = e.data.operator_10_25
          arr[3].value = e.data.operator_25_35
          arr[4].value = e.data.operator_35
          that.titleArr = [...arr]
        })
    },
    initData() {
      let that = this
      let energyType = getFuelTypeCode(this.fuelType);
      let arr = that.value4.split('-')
      let type = get(this,"dimObj.type","0")
      let firstPageLoad=this.firstLoaded?1:0;
      http.carOperateTon({
          condition: that.titleArr[that.dataType].key,
          registYear: arr[1]=='00'?arr[0]-1:arr[0],
          registMonth: arr[1]=='00'?'12':arr[1],
          energyType,
          type,
          firstPageLoad,
        }).then(e => {
          if(this.firstLoaded){
            this.firstLoaded=false;
            if(e.data&&e.data.time){
              that.value4=e.data.time;
              let arr = that.value4.split('-')
              set(this,"dimObj.year",arr[0])
              set(this,"dimObj.month",arr[1])
              this.$refs.objDimensionPopover.setCtrlValue();
            }
          }
        	that.initTit();
          if (e.data && e.data.mapRangeList) {
            for (let i = 0; i < e.data.mapRangeList.length; i++) {
              e.data.mapRangeList[i].label = that.nounArr[i]
              // if (e.data.mapRangeList[i].end == -1) {
              //   e.data.mapRangeList[i].label =
              //     e.data.mapRangeList[i].start + ' 以上'
              //   delete e.data.mapRangeList[i].end
              // }
            }
            that.mapRangeList = [...e.data.mapRangeList]
            that.dataItem = that.handleSeriesData({
              data: e.data.resultList,
              index: that.dataType
            })
            this.showtip=false
          } else {
           that.dataItem = []
            that.mapRangeList=[{end:0,start:0,label:"无"}]
            this.showtip=true
          }
        })
    },
    changeDimension(e){
      if(e.isOk){
        this.value4 = e.year+"-"+e.month;
        this.dimObj.year = e.year;
        this.dimObj.month = e.month;
        this.dimObj.type = e.type;
        this.changeTime();
      }
    },
    changeTime() {
      this.initData()
    },
    handleSeriesData({ index = 0, data }) {
      let that = this
      let arrs = JSON.stringify(data)
      let handleArr = JSON.parse(arrs)
      handleArr.forEach(e => {
        e.name = e.registProvince.slice(0, e.registProvince.length - 1)
        e.yyValue = e.yyOperatorSubtotal
        if (index == 0) {
          e.value = e.operatorSubtotal
        } else if (index == 1) {
          e.value = e.operator_0_10
        } else if (index == 2) {
          e.value = e.operator_10_25
        } else if (index == 3) {
          e.value = e.operator_25_35
        } else if (index == 4) {
          e.value = e.operator_35
        } else {
          e.value = e.operatorSubtotal
        }
      })
      return handleArr
    },
    exportDate() {
      this.showExport=true
      return
      let that = this
      that.mark = true
      let reqId = Cookies.get('user')
      window.times = setInterval(function() {
        http.progress({ reqId }).then(e => {
          that.progressNum = e.data.percent
          if (e.data.percent >= 100) {
            that.mark = false
            that.progressNum = 0
            clearInterval(window.times)
          }
        })
      }, 100)
      reqId += new Date() * 1
      let arr = that.value4.split('-')
      window.location.assign(
        http.carOperateTonExport({
          registYear: arr[0],
          registMonth: arr[1],
          reqId
        })
      )
    }
  }
}
</script>
